import { openSnackbar } from 'api/snackbar';
import type { SnackbarProps } from 'types/snackbar';

const SNACKBAR_BASE: Pick<
  SnackbarProps,
  'action' | 'anchorOrigin' | 'transition' | 'close' | 'actionButton' | 'maxStack' | 'dense' | 'iconVariant'
> = {
  action: false,
  anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
  transition: 'Fade',
  close: false,
  actionButton: false,
  maxStack: 3,
  dense: false,
  iconVariant: 'usedefault',
};

function push(message: string, color: 'success' | 'error' | 'warning' | 'info' | 'primary') {
  openSnackbar({
    ...SNACKBAR_BASE,
    open: true,
    message,
    variant: 'alert',
    alert: { color, variant: 'filled' },
  } as SnackbarProps);
}

/** App-wide transient feedback via the existing MUI snackbar + SWR-backed `openSnackbar`. */
export const notify = {
  success: (message: string) => push(message, 'success'),
  error: (message: string) => push(message, 'error'),
  warning: (message: string) => push(message, 'warning'),
  info: (message: string) => push(message, 'info'),
  primary: (message: string) => push(message, 'primary'),
};
